import HeroCursos from "components/hero/HeroCursos";
import SideBarNavigation from "components/Menu/SideBarNavigation";
import React, { useEffect, useState } from "react";
import dataCursos from '../data/cursos.json'


function Test() {
  const [numSections, setNumSections] = useState(null);
  const [offsetList,setOffsetList] = useState([]);
  useEffect(() => {
    const sections = document.querySelectorAll("section");
    setNumSections(sections.length);
    sections.forEach((section) => {
      setOffsetList(prev => [...prev, section.offsetTop]);
    });
    
    
  }, []);

  const cursos = dataCursos
  console.log(cursos);
  

  return (
    <>
      <HeroCursos />

      <SideBarNavigation num={numSections} sectionOffsets={offsetList} />
      <section id="2" className="min-h-screen bg-white">
        <h1>Test Page</h1>
        <p>This is a simple test page.</p>
      </section>
      <section id="3" className="min-h-screen bg-primario"></section>
      <section id="4" className="min-h-screen bg-white"></section>
      <section id="5" className="min-h-screen bg-primario"></section>
    </>
  );
}

export default Test;
